import { BaseEntity } from './base-raptor-models';

export enum ExternalProviderType {
    Carfax = 'Carfax',
    PartsTechPartner = 'PartsTechPartner',
    PartsTechUser = 'PartsTechUser',
    TechCheckAppAccessEmail = 'TechCheckAppAccessEmail',
    TechCheckAppAccessPassword = 'TechCheckAppAccessPassword',
    TechCheckTechnicianPin = 'TechCheckTechnicianPin',
    TwilioAccount = 'TwilioAccount',
}

export interface ExternalProvider extends BaseEntity {
    apiId?: string | null;
    apiKey?: string | null;
    type: ExternalProviderType;
    userId?: string | null;
}
